import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const navLinks = [
  { label: "Home",        to: "/" },
  { label: "About",       to: "/about" },
  { label: "Projects",    to: "/projects" },
  { label: "Contact",     to: "/contact" },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-shell">
        <div className="footer-brand">
          <p className="footer-eyebrow">Astra Concepts</p>
          <h2 className="footer-title">Aluminum Design Systems</h2>
        </div>

        <nav className="footer-nav" aria-label="Footer navigation">
          {navLinks.map((link) => (
            <Link key={link.label} to={link.to} className="footer-link">
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="footer-social">
          <span className="footer-social-label">Instagram</span>
          <a
            href="https://www.instagram.com/astraconcepts.ca"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social-link"
          >
            @astraconcepts.ca
          </a>
          <span className="footer-social-label">Sister Company</span>
          <a
            href="https://varsa.ca"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social-link"
          >
            varsa.ca
          </a>
        </div>
      </div>

      <div className="footer-meta">
        <span>© {currentYear} Astra Concepts. All rights reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;
